'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    DragItemTypes = require('../constants/DragItemTypes'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ImageCaption = require('./ImageCaption'),
    ImageSizes = require('../constants/ImageSizes'),
    createFlexibleImageQueueMixin = require('../mixins/createFlexibleImageQueueMixin'),
    update = require('react/lib/update'),
    { DragDropMixin, ImagePreloaderMixin, DropEffects } = require('react-dnd'),
    { PropTypes } = React;

require('./EditorGalleryImage.less');

var EditorGalleryImage = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, createFlexibleImageQueueMixin(1)],

  className: 'editor-GalleryImage',

  propTypes: {
    galleryId: PropTypes.any.isRequired,
    image: PropTypes.object.isRequired,
    isNew: PropTypes.bool,
    onDeleteClick: PropTypes.func.isRequired,
    onDropToOtherSection: PropTypes.func.isRequired
  },

  getImageOptions() {
    return {
      image: this.props.image,
      mode: 'scale_crop',
      sizes: {
        thumb: true,
        normal: true,
        retina: window.devicePixelRatio > 1.5
      }
    };
  },

  getImageDragPreviewUrl() {
    var image = this.props.image,
        scale = this.getDragImageScale();

    return getThumbnailUrl(image, {
      mode: 'preview',
      width: Math.round(ImageSizes.EDITOR_GALLERY_IMAGE_DRAG.width * scale),
      height: Math.round(ImageSizes.EDITOR_GALLERY_IMAGE_DRAG.height * scale)
    });
  },

  getImageUrlsToPreload() {
    return [this.getImageDragPreviewUrl()];
  },

  configureDragDrop(registerType) {
    registerType(DragItemTypes.IMAGE, {
      dragSource: {
        canDrag() {
          return this.hasPreloadedImage(this.getImageDragPreviewUrl());
        },

        beginDrag() {
          return {
            effectsAllowed: [DropEffects.MOVE],
            dragPreview: this.getPreloadedImage(this.getImageDragPreviewUrl()),
            item: {
              image: this.props.image,
              galleryId: this.props.galleryId
            }
          };
        },

        endDrag(dropEffect) {
          if (dropEffect === DropEffects.MOVE) {
            this.props.onDropToOtherSection(this.props.image.uuid);
          }
        }
      },

      dropTarget: {
        canDrop(item) {
          return item.galleryId === this.props.galleryId;
        },

        over(item) {
          var draggedImageId = item.image.uuid,
              overImageId = this.props.image.uuid;

          if (draggedImageId === overImageId) {
            return;
          }

          DraftActionCreators.moveGalleryImage(this.props.galleryId, draggedImageId, overImageId);
        }
      }
    });
  },

  componentDidMount() {
    if (this.props.isNew) {
      this.getDOMNode().scrollIntoViewIfNeeded();
      DraftActionCreators.resetLastAddedItem();
    }
  },

  componentDidUpdate(prevProps) {
    if (prevProps.image !== this.props.image) {
      this.updateImageQueue();
    }
  },

  render() {
    var caption = this.props.image.caption;

    return (
      <div className={this.getClassName()}
           data-dragging={this.getDragState(DragItemTypes.IMAGE).isDragging}>


        <div className="editor-GalleryImage-image"
             style={{backgroundImage: this.getBackgroundImageUrl()}}
             data-dragging={this.getDragState(DragItemTypes.IMAGE).isDragging}
             {...this.dragSourceFor(DragItemTypes.IMAGE)}
             {...this.dropTargetFor(DragItemTypes.IMAGE)}>
          {this.renderLoaderImg()}
        </div>


        <Button size='xsmall'
                round
                overlay
                color='black'
                className='editor-GalleryImage-delete'
                onClick={this.handleDeleteClick}>
          <Icon name='cross'
                size='xxsmall'
                mode='stroke' />
        </Button>

        <ImageCaption text={caption}
                      onChange={this.handleCaptionChange} />
      </div>
    );
  },

  handleCaptionChange(textContent) {
    var imageUpdate = update(this.props.image, {
      caption: { $set: textContent }
    });

    if (this.props.image.caption === textContent) {
      return;
    }

    DraftActionCreators.updateGalleryImage(this.props.galleryId, this.props.image.uuid, imageUpdate);
  },

  handleDeleteClick() {
    this.props.onDeleteClick(this.props.image.uuid);
  }
});

module.exports = EditorGalleryImage;



/** WEBPACK FOOTER **
 ** ./editor/EditorGalleryImage.jsx
 **/